export default "__VITE_ASSET__BUL7Xr_x__"